import { BillHistory } from './bill-history.component';

export { BillHistory };
